/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectCostChangeCreateProjectCostChangePost } from '../fn/project-cost-changes/api-project-cost-change-create-project-cost-change-post';
import { ApiProjectCostChangeCreateProjectCostChangePost$Params } from '../fn/project-cost-changes/api-project-cost-change-create-project-cost-change-post';
import { apiProjectCostChangeCreateProjectCostChangePost$Plain } from '../fn/project-cost-changes/api-project-cost-change-create-project-cost-change-post-plain';
import { ApiProjectCostChangeCreateProjectCostChangePost$Plain$Params } from '../fn/project-cost-changes/api-project-cost-change-create-project-cost-change-post-plain';
import { apiProjectCostChangeDeleteProjectCostChangeDelete } from '../fn/project-cost-changes/api-project-cost-change-delete-project-cost-change-delete';
import { ApiProjectCostChangeDeleteProjectCostChangeDelete$Params } from '../fn/project-cost-changes/api-project-cost-change-delete-project-cost-change-delete';
import { apiProjectCostChangeDeleteProjectCostChangeDelete$Plain } from '../fn/project-cost-changes/api-project-cost-change-delete-project-cost-change-delete-plain';
import { ApiProjectCostChangeDeleteProjectCostChangeDelete$Plain$Params } from '../fn/project-cost-changes/api-project-cost-change-delete-project-cost-change-delete-plain';
import { apiProjectCostChangeGetAllProjectCostChangesPost } from '../fn/project-cost-changes/api-project-cost-change-get-all-project-cost-changes-post';
import { ApiProjectCostChangeGetAllProjectCostChangesPost$Params } from '../fn/project-cost-changes/api-project-cost-change-get-all-project-cost-changes-post';
import { apiProjectCostChangeGetAllProjectCostChangesPost$Plain } from '../fn/project-cost-changes/api-project-cost-change-get-all-project-cost-changes-post-plain';
import { ApiProjectCostChangeGetAllProjectCostChangesPost$Plain$Params } from '../fn/project-cost-changes/api-project-cost-change-get-all-project-cost-changes-post-plain';
import { apiProjectCostChangeGetCostChangeGet } from '../fn/project-cost-changes/api-project-cost-change-get-cost-change-get';
import { ApiProjectCostChangeGetCostChangeGet$Params } from '../fn/project-cost-changes/api-project-cost-change-get-cost-change-get';
import { apiProjectCostChangeGetCostChangeGet$Plain } from '../fn/project-cost-changes/api-project-cost-change-get-cost-change-get-plain';
import { ApiProjectCostChangeGetCostChangeGet$Plain$Params } from '../fn/project-cost-changes/api-project-cost-change-get-cost-change-get-plain';
import { CreateProjectCostChangeCommandResult } from '../models/create-project-cost-change-command-result';
import { DeleteProjectCostChangeCommandResult } from '../models/delete-project-cost-change-command-result';
import { GetCostChangeQueryResult } from '../models/get-cost-change-query-result';
import { GetCostChangesQueriesResult } from '../models/get-cost-changes-queries-result';

@Injectable({ providedIn: 'root' })
export class ProjectCostChangesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectCostChangeGetAllProjectCostChangesPost()` */
  static readonly ApiProjectCostChangeGetAllProjectCostChangesPostPath = '/api/ProjectCostChange/GetAllProjectCostChanges';

  /**
   * Get All Cost Changes for project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeGetAllProjectCostChangesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeGetAllProjectCostChangesPost$Plain$Response(params?: ApiProjectCostChangeGetAllProjectCostChangesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCostChangesQueriesResult>> {
    return apiProjectCostChangeGetAllProjectCostChangesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Cost Changes for project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeGetAllProjectCostChangesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeGetAllProjectCostChangesPost$Plain(params?: ApiProjectCostChangeGetAllProjectCostChangesPost$Plain$Params, context?: HttpContext): Observable<GetCostChangesQueriesResult> {
    return this.apiProjectCostChangeGetAllProjectCostChangesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCostChangesQueriesResult>): GetCostChangesQueriesResult => r.body)
    );
  }

  /**
   * Get All Cost Changes for project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeGetAllProjectCostChangesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeGetAllProjectCostChangesPost$Response(params?: ApiProjectCostChangeGetAllProjectCostChangesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCostChangesQueriesResult>> {
    return apiProjectCostChangeGetAllProjectCostChangesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Cost Changes for project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeGetAllProjectCostChangesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeGetAllProjectCostChangesPost(params?: ApiProjectCostChangeGetAllProjectCostChangesPost$Params, context?: HttpContext): Observable<GetCostChangesQueriesResult> {
    return this.apiProjectCostChangeGetAllProjectCostChangesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCostChangesQueriesResult>): GetCostChangesQueriesResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCostChangeGetCostChangeGet()` */
  static readonly ApiProjectCostChangeGetCostChangeGetPath = '/api/ProjectCostChange/GetCostChange';

  /**
   * Get Specific Project Cost Change.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeGetCostChangeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCostChangeGetCostChangeGet$Plain$Response(params: ApiProjectCostChangeGetCostChangeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCostChangeQueryResult>> {
    return apiProjectCostChangeGetCostChangeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Specific Project Cost Change.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeGetCostChangeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCostChangeGetCostChangeGet$Plain(params: ApiProjectCostChangeGetCostChangeGet$Plain$Params, context?: HttpContext): Observable<GetCostChangeQueryResult> {
    return this.apiProjectCostChangeGetCostChangeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCostChangeQueryResult>): GetCostChangeQueryResult => r.body)
    );
  }

  /**
   * Get Specific Project Cost Change.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeGetCostChangeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCostChangeGetCostChangeGet$Response(params: ApiProjectCostChangeGetCostChangeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCostChangeQueryResult>> {
    return apiProjectCostChangeGetCostChangeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Specific Project Cost Change.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeGetCostChangeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectCostChangeGetCostChangeGet(params: ApiProjectCostChangeGetCostChangeGet$Params, context?: HttpContext): Observable<GetCostChangeQueryResult> {
    return this.apiProjectCostChangeGetCostChangeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCostChangeQueryResult>): GetCostChangeQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCostChangeCreateProjectCostChangePost()` */
  static readonly ApiProjectCostChangeCreateProjectCostChangePostPath = '/api/ProjectCostChange/CreateProjectCostChange';

  /**
   * دا علشان تضيف تكلفة ع المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeCreateProjectCostChangePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeCreateProjectCostChangePost$Plain$Response(params?: ApiProjectCostChangeCreateProjectCostChangePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCostChangeCommandResult>> {
    return apiProjectCostChangeCreateProjectCostChangePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تضيف تكلفة ع المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeCreateProjectCostChangePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeCreateProjectCostChangePost$Plain(params?: ApiProjectCostChangeCreateProjectCostChangePost$Plain$Params, context?: HttpContext): Observable<CreateProjectCostChangeCommandResult> {
    return this.apiProjectCostChangeCreateProjectCostChangePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectCostChangeCommandResult>): CreateProjectCostChangeCommandResult => r.body)
    );
  }

  /**
   * دا علشان تضيف تكلفة ع المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeCreateProjectCostChangePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeCreateProjectCostChangePost$Response(params?: ApiProjectCostChangeCreateProjectCostChangePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCostChangeCommandResult>> {
    return apiProjectCostChangeCreateProjectCostChangePost(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تضيف تكلفة ع المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeCreateProjectCostChangePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeCreateProjectCostChangePost(params?: ApiProjectCostChangeCreateProjectCostChangePost$Params, context?: HttpContext): Observable<CreateProjectCostChangeCommandResult> {
    return this.apiProjectCostChangeCreateProjectCostChangePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectCostChangeCommandResult>): CreateProjectCostChangeCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectCostChangeDeleteProjectCostChangeDelete()` */
  static readonly ApiProjectCostChangeDeleteProjectCostChangeDeletePath = '/api/ProjectCostChange/DeleteProjectCostChange';

  /**
   * دا علشان تمسح تكلفة من المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeDeleteProjectCostChangeDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeDeleteProjectCostChangeDelete$Plain$Response(params?: ApiProjectCostChangeDeleteProjectCostChangeDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCostChangeCommandResult>> {
    return apiProjectCostChangeDeleteProjectCostChangeDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح تكلفة من المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeDeleteProjectCostChangeDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeDeleteProjectCostChangeDelete$Plain(params?: ApiProjectCostChangeDeleteProjectCostChangeDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectCostChangeCommandResult> {
    return this.apiProjectCostChangeDeleteProjectCostChangeDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectCostChangeCommandResult>): DeleteProjectCostChangeCommandResult => r.body)
    );
  }

  /**
   * دا علشان تمسح تكلفة من المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectCostChangeDeleteProjectCostChangeDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeDeleteProjectCostChangeDelete$Response(params?: ApiProjectCostChangeDeleteProjectCostChangeDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCostChangeCommandResult>> {
    return apiProjectCostChangeDeleteProjectCostChangeDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح تكلفة من المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectCostChangeDeleteProjectCostChangeDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectCostChangeDeleteProjectCostChangeDelete(params?: ApiProjectCostChangeDeleteProjectCostChangeDelete$Params, context?: HttpContext): Observable<DeleteProjectCostChangeCommandResult> {
    return this.apiProjectCostChangeDeleteProjectCostChangeDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectCostChangeCommandResult>): DeleteProjectCostChangeCommandResult => r.body)
    );
  }

}
